import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  CheckReservation,
  CheckReservationSuccess,
  CheckReservationFailure,
  ReservationActionTypes
} from '../actions/reservation.action';

import { ProductsService } from '@vestiaire/api-sdk-angular';

@Injectable()
export class ReservationEffects {
  @Effect()
  checkReservation$ = this.actions$.pipe(
    ofType(ReservationActionTypes.CheckReservation),
    map((action: CheckReservation) => action.payload),
    switchMap(action => {
      return this.productsService.getProductReservation(action.productId).pipe(
        map(
          result =>
            new CheckReservationSuccess({
              productId: action.productId,
              reservation: result.data
            })
        ),
        catchError(error => of(new CheckReservationFailure()))
      );
    })
  );

  constructor(private actions$: Actions, private productsService: ProductsService) {}
}
